import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Routes, Route } from "react-router-dom";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { TicketTypeEnum } from "../../../_common/enum/ticketType.enum";
import { ticketService } from "../../../_services/ticket.service";
import { TicketResultEnum } from "../../../_common/enum/ticketResult.enum";
import { StandardViewPanel } from "../../../_components/panel/standardView.panel";
import { TicketInfoManageDrawer } from "./ticket-infoManageDrawer";
import { accountService } from "../../../_services/accounts.service";
import { getDateFromString } from "../../../_helpers/dateTime.helper";


export function TicketInfoPanel(params: { setPaymentDate: (date?: string) => void, setInvoiceNumber: (date?: string) => void }) {

    const resetData = () => ({});

    const { id, ticketType } = useParams<{ id: string, ticketType?: string }>();
    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [paymentDate, setPaymentDate] = useState<string>();
    const [invoiceNumber, setInvoiceNumber] = useState<string>();
    const initialTitleRef = useRef(document.title);

    useEffect(() => {
        fetchData()
    }, [id]);

    function fetchData() {
        if (!id) return;
        setIsLoading(true);
        return ticketService
            .get(id, ticketType)
            .then(
                (json) => {
                    console.log(json);
                    if (json && json.ticketAgents && json.ticketAgents.length) {
                        json.ticketAgents = json.ticketAgents.map((e: any) => ({
                            id: e.userId,
                            name: e.user.name,
                        }));
                    }
                    params.setPaymentDate(json?.paymentDate)
                    params.setInvoiceNumber(json?.invoiceNumber)
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function splitByCapital(text?: string) {
        if (!text) return "";
        return text
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
            .trim();
    }

    useEffect(() => {
        return () => {
            document.title = initialTitleRef.current;
        };
    }, []);

    useEffect(() => {
        if (!id) return;
        const refNumber = (data?.ticketReferenceNumber ?? "").toString().replace(/\s+/g, "");
        const typeLabel = splitByCapital(TicketTypeEnum[data?.ticketTypeId]);
        if (!refNumber || !typeLabel) return;

        document.title = `Aserve - ${refNumber} - ${typeLabel}`;
    }, [id, data?.ticketReferenceNumber, data?.ticketTypeId]);

    const rows = [
        { label: 'Type', value: TicketTypeEnum[data.ticketTypeId] },
        { label: 'Ref N:', value: data.ticketReferenceNumber },
        { label: 'Status', value: data.ticketStatusName },
        ...(data.ticketTypeId === TicketTypeEnum.Serve ? [{
            label: 'LDS',
            value: data?.lds != null ? getDateFromString(data.lds) : undefined,
        }] : []),
        { label: 'Case Subject', value: data.caseSubjectName },
        { label: 'Agents', value: data.ticketAgents?.map((agent: any) => agent.name).join(", ") },
        { label: 'Ticket Result', value: TicketResultEnum[data.ticketResultId], visible: accountService.isAdmin  },
        { label: 'Invoice Number', value: data.invoiceNumber, visible: accountService.isAdmin },
        { label: 'Payment Date', value: data?.paymentDate != null ? getDateFromString(data.paymentDate) : "", visible: accountService.isAdmin },
    ]

    return (
        <>
            <StandardViewPanel
                title="Ticket Info" buttons={(accountService.isAdmin || accountService.isUser) ? [
                    { icon: "edit", onClick: () => { navigate("ManageTicket/" + data.id) }, disabled: !data?.id }
                ] :
                //[{ icon: "visibility", onClick: () => { navigate("ManageTicket/" + data.id) } }]
                []
                }
                loading={isLoading}
                items={rows} />


            <Routes>
                <Route path="ManageTicket/:id" element={<TicketInfoManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate(""); fetchData(); }} />} />
            </Routes>
        </>
    );
};

